import apiClient from './apiClient';
import type { Resultado } from '../types/cuestionario';

export interface PushSubscriptionPayload {
  endpoint: string;
  keys: { p256dh: string; auth: string };
}

export interface Activar2FAResponse {
  secret: string;
  qrCode: string;
  message?: string;
}

// Perfil: exportación GDPR, 2FA real y suscripción Web Push (Fase 6).
export const perfilService = {
  /**
   * Historial de evaluaciones del estudiante.
   *
   * Una de las tres fuentes del historial de actividad (P7). El endpoint ya
   * existía y es una consulta Prisma real (`PerfilController.getHistorialEvaluaciones`,
   * `prisma.resultado` ordenado por `fechaEvaluacion`); lo que faltaba era el
   * metodo en el cliente.
   */
  async getHistorialEvaluaciones(): Promise<Resultado[]> {
    const response = await apiClient.get<Resultado[]>('/perfil/historial-evaluaciones');
    return response.data;
  },

  async descargarDatos(): Promise<Blob> {
    // apiClient agrega el header Authorization (interceptor): sin esto el
    // fetch crudo devolvía 401 (Fase 6.3).
    const response = await apiClient.get<Blob>('/perfil/descargar-datos', {
      responseType: 'blob',
    });
    return response.data;
  },

  async activar2FA(): Promise<Activar2FAResponse> {
    const response = await apiClient.post<Activar2FAResponse>('/perfil/2fa/activar');
    return response.data;
  },

  async validar2FA(codigo: string): Promise<{ valido: boolean }> {
    const response = await apiClient.post<{ valido: boolean }>('/perfil/2fa/validar', { codigo });
    return response.data;
  },

  async desactivar2FA(): Promise<unknown> {
    const response = await apiClient.post('/perfil/2fa/desactivar');
    return response.data;
  },

  async guardarSuscripcionPush(subscription: PushSubscriptionPayload): Promise<unknown> {
    const response = await apiClient.post('/perfil/suscripcion-push', subscription);
    return response.data;
  },

  async eliminarSuscripcionPush(endpoint: string): Promise<unknown> {
    const response = await apiClient.delete('/perfil/suscripcion-push', { data: { endpoint } });
    return response.data;
  },
};
